module.exports = __webpack_public_path__ + "static/img/11.cbeb455.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/ban-th/11.jpg
// module id = 8Ixq
// module chunks = 1